import { useMemo } from 'react';
import { formatMatchTime } from '@/utils/matches';

interface TimeDisplayProps {
  beginAt: string | undefined;
}

export const TimeDisplay = ({ beginAt }: TimeDisplayProps) => {
  const formattedTime = useMemo(() => {
    return formatMatchTime(beginAt);
  }, [beginAt]);

  return (
    <p className="rounded-lg bg-white-o20 px-3 py-1 font-semibold text-white text-xs leading-3">
      {formattedTime}
    </p>
  );
};
